import {CMPWindow} from "../../c-m-p-window";
import {UIEvent} from "../../../u-i-event";
import {TEvent, TEventSubtype} from "services-comun-meteored/modules/services/cmp/web/events";
import AnalyticManager from "../../../../analytic/analytic-manager";
import {EAction, ELabel} from "../../../../analytic/event-definition";
import {ApareceGlobal} from "../../../../session/aparece-global";
import {publish} from "../../../../util/js-event";
import {ECMPWindow} from "../../interface";
import {IIdioma} from "services-comun/modules/net/i18n/net";
import {site} from "../../../../context/context";
import traduccion from "i18n/cmp/auto_accept_window";
import {ELogLabel, log} from "../../../../util/log";
import {yieldToMainBackground} from "services-comun/modules/browser/task";
import {EAutoAcceptEvent, IPrivacityEvent} from "./interface";
import {Idioma, IdiomaCorto} from "services-comun/modules/net/i18n";
import type {Langs} from "i18n/langs";

interface ILang {
    main_text: string;
    button_text: string;
}

interface IConfigureEvent {
}

export class AutoAcceptWindow extends CMPWindow {
    /* STATIC */

    private static _INSTANCE: AutoAcceptWindow;

    public static instance(): AutoAcceptWindow {
        return this._INSTANCE ??= new AutoAcceptWindow(ECMPWindow.AUTO_ACCEPT);
    }

    /* INSTANCE */
    private _LANG: ILang|undefined;

    private _panel: HTMLElement|undefined;

    private get panel(): HTMLElement {
        if (!this._panel) {
            throw new Error('Panel no inicializado');
        }
        return this._panel;
    }

    public open(): void {
        this.buildPanel().then(async container => {

            this._panel = container;

            // Lanza el evento de apertura
            const event = UIEvent.create(TEvent.APARECE_AUTO_ACCEPT);
            event.register();
            event.notify();

            // Lanzamos evento analítico
            AnalyticManager().register({
                action: EAction.AUTO_ACCEPT,
                label: ELabel.APARECE
            });

            if (ApareceGlobal.get().key !== '1') {
                AnalyticManager().register({
                    action: EAction.GDPR,
                    label: ELabel.APARECE_GLOBAL
                });
            }

            this.managePanel();
        });
    }

    private async buildPanel(): Promise<HTMLElement> {
        const template = require("../../../template/auto-accept-window.pug");

        require(`cmp-web-templates/scss/auto-accept.scss`);

        await yieldToMainBackground();

        const lang = await this.loadI18N();

        const html = template({
            'main_text': lang.main_text,
            'button_text': lang.button_text
        });

        const element: HTMLDivElement = document.createElement('div');
        element.innerHTML = html;

        const mainContainer: HTMLElement = <HTMLElement>element.firstElementChild;

        const selector = site.autoAcceptConfig()?.wc ?? 'body';
        const container = document.querySelector(selector) || document.body;

        if (container) {
            log.debug(`Cargando ventana de auto aceptación en el contenedor ${selector}`, undefined, ELogLabel.UI);
            container.insertAdjacentElement('afterbegin', mainContainer);

            await yieldToMainBackground();
        } else {
            log.debug('No se ha encontrado el contenedor para el panel de auto-aceptación', undefined, ELogLabel.UI);
        }

        return mainContainer;
    }

    private managePanel(): void {
        // Panel
        const panel = this.panel;

        // Click sobre el elemento privacity
        const privacity: HTMLElement = <HTMLElement>panel.querySelector('#url-policy');
        if (privacity) {
            privacity.onclick = () => {
                publish<IPrivacityEvent>(EAutoAcceptEvent.PRIVACIDAD, {
                    url_privacidad: privacity.dataset['link'] || ''
                });
            };
        }

        // Botón de configurar
        const configure: HTMLElement = <HTMLElement>panel.querySelector('#btn-gdpr-configure');
        if (configure) {
            configure.onclick = () => {
                publish<IConfigureEvent>(EAutoAcceptEvent.CONFIGURAR, {});
            };
        }

        // Botón de cerrar
        const close: HTMLElement = <HTMLElement>panel.querySelector('.cerrar_cmp');
        if (close) {
            close.onclick = async () => {
                await this.close();
            };
        }

        // Scroll
        const initScroll = scrollY;
        window.addEventListener('scroll', async () => {
            if (Math.abs(scrollY - initScroll) > 50) {
                await this.close();
            }
        });
    }

    private async loadI18N(): Promise<ILang> {
        if (!this._LANG) {

            const idioma: IIdioma = {
                idioma: site.language as Idioma,
                idioma_corto: site.language.split('-')[0] as IdiomaCorto,
                defecto: 'en',
                defecto_corto: 'en'
            };

            const lang = await traduccion(idioma.idioma as Langs);

            this._LANG = {
                main_text: lang.aaw_main_message({
                    url_privacidad: site.autoAcceptConfig()?.pu ?? ''
                }),
                button_text: lang.aaw_open_config
            };
        }
        return this._LANG;
    }

    public override async close(): Promise<void> {
        if (this.panel) {
            this.panel.remove();

            await yieldToMainBackground();

            // Lanza el evento de cierre de la ventana
            const event = UIEvent.create(TEvent.CIERRA_CMP, TEventSubtype.AUTO_ACCEPT_LAYER);
            event.register();
            event.notify();
        }
    }

}
